import { useEffect, useState } from 'react';
import { WhatsAppModelAPI } from '../WhatsAppModelAPI';

/**
 * Custom hook to poll WhatsApp unread message count.
 * Polls every 30 seconds when enabled.
 * 
 * @param {boolean} enabled - Whether to enable polling (default: true)
 * @returns {number} The current count of unread WhatsApp messages
 */
export const useWhatsAppNotifications = (enabled: boolean = true): number => {
    const [unreadCount, setUnreadCount] = useState<number>(0);

    useEffect(() => {
        if (!enabled) {
            return;
        }

        const fetchUnreadCount = async () => {
            try {
                const count = await WhatsAppModelAPI.getUnreadCount();
                setUnreadCount(count);
            } catch (err) {
                console.error('Error fetching WhatsApp unread count:', err);
            }
        };

        // Fetch immediately on mount
        fetchUnreadCount();

        // Poll every 30 seconds
        const interval = setInterval(fetchUnreadCount, 30000);

        return () => {
            clearInterval(interval);
        };
    }, [enabled]);

    return unreadCount;
};
